import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Table,
  Row,
  Col,
  CardTitle,
  CardText,
  CardFooter,
} from "reactstrap";
import classnames from "classnames";
import img from "../../assets/img/brand/goodybuddy_short.png";
import adminModel from "models/admin.model";
import { helper } from "lib/helper";
import experienceModel from "models/experience.model";
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper"; // Import your generic filter function

const RatingExperience = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const initialExperience = location.state?.experience || {};
  const [activeTab, setActiveTab] = useState("1");
  const { id } = useParams();

  const navigate = useNavigate();

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [ratingData, setRatingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");

  const getRatingDetails = async () => {
    setIsLoading(true);
    await experienceModel
      .ratingDetails(id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setRatingData(result?.data?.reviews);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  // console.log(ratingData, "+++++++++++++++ratingData");

  // Use your filterItems function to filter data based on the search query
  const filteredDataList = filterItems(ratingData, searchQuery, [
    "buddyname",
    "mob",
    "experienceType",
    "goods",
    "services",
    "audienceFor",
  ]);

  // Calculate the items to display for the current page
  const startIndex = (currentPage - 1) * perPage;
  const endIndex = startIndex + perPage;
  const paginatedDataList = filteredDataList.slice(startIndex, endIndex);

  // Calculate the index of the first and last user on the current page
  const indexOfLastUser = currentPage * perPage;
  const indexOfFirstUser = indexOfLastUser - perPage;

  // Filter users based on search query
  const filteredUsers = filterItems(filteredDataList, searchQuery, [
    "firstName",
    "email",
    "mob",
  ]);

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page when pagination is clicked
  };

  const handleDeleteRating = (delId) => {
    helper.sweetalert
      .confirm(
        "Are You sure you want to delete  this rating & reviews?",
        "info",
        true
      )
      .then((result) => {
        if (result.isConfirmed) {
          experienceModel.deleteRatingAndReviews(delId).then((res) => {
            helper.sweetalert.toast(res?.data?.message);
            getRatingDetails();
          });
        }
      });
  };

  useEffect(() => {
    getRatingDetails();
  }, [location]);

  return (
    <Container className="pt-0">
      <Card className="shadow">
        {ratingData.length === 0 ? (
          <h3 className="text-center">No Reviews yet</h3>
        ) : (
          <>
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Name</th>
                  <th scope="col">Title</th>
                  <th scope="col">Description</th>
                  <th scope="col">Rating</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {ratingData?.map((item, index) => {
                  return (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>
                        {item?.user?.firstName} {item?.user?.lastName}
                      </td>
                      <td>{item.experience?.title}</td>
                      <td>{item?.experience?.description}</td>
                      <td>{item.rating}</td>
                      <td>
                        {/* <Button color="primary" size="sm" className="mr-2" onClick={() => navigate('/admin/user/view/' + item._id)}><i className="fa-solid fa-info"></i></Button>
                    <Button color="primary" size="sm" className="mr-2">Listing</Button>
                    <Button color="warning" size="sm" className="mr-2" onClick={() => navigate('/admin/user/edit/' + item._id)}><i className="fa-regular fa-pen-to-square"></i></Button> */}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => handleDeleteRating(item._id)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              <TablePagination
                totalPages={Math.ceil(filteredUsers.length / perPage)}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                pageUrl="/admin/users?"
              />
            </CardFooter>
          </>
        )}
      </Card>
    </Container>
  );
};

export default RatingExperience;
